import b from 'b_';
import cx from 'classnames';
import { Close as IconClose } from 'education-icons';
import { SimpleCallback } from 'platform-components';
import PropTypes from 'prop-types';
import React from 'react';

// @ts-ignore
import { IconWarningTriangle } from 'common.components/icon2';

import { NOTIFICATION_THEME } from '../typings';

interface Props {
    mix?: string;
    theme: NOTIFICATION_THEME;
    onClose: SimpleCallback;
}

export default class ChangesNotification extends React.PureComponent<React.PropsWithChildren<Props>> {
    static contextTypes = {
        prefix: PropTypes.string.isRequired,
        staticUrls: PropTypes.object.isRequired,
    };

    render() {
        const { onClose, children, theme, mix } = this.props;

        return (
            <div className={cx(b('changes-notification', { theme }), mix)}>
                <div className="changes-notification__message">
                    <IconWarningTriangle mix="changes-notification__icon" />
                    {children}
                </div>
                <div className="changes-notification__controls">
                    <IconClose className="changes-notification__icon-close" onClick={onClose} />
                </div>
            </div>
        );
    }
}
